import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import WhitepaperContent from "../components/WhitepaperContent";

const Whitepaper = () => {
  return (
    <div>
      <Header />
      <WhitepaperContent />
      <Footer />
    </div>
  );
};

export default Whitepaper;
